var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-aligned" },
    [
      _c("CustomButton", {
        attrs: {
          icon: "el-icon-arrow-left",
          StyleSheet: "padding: 0.2rem 0.7rem"
        },
        on: {
          click: function($event) {
            return _vm.voltar()
          }
        }
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "m-1" }, [
        _vm._v(
          " " + _vm._s(_vm.hasProcesso ? "Editar Cadastro" : _vm.label) + " "
        )
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e064de3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e064de3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/HeaderVoltar/HeaderVoltar.vue
// module id = null
// module chunks = 